import './Providers.css';

const providers = [
  {
    name: 'Amazon Web Services',
    logo: '/images/cloud/aws.webp',
    description:
      'Advanced cloud infrastructure, security, and managed services for AWS-powered enterprises.',
  },
  {
    name: 'Microsoft Azure',
    logo: '/images/cloud/azure.webp',
    description:
      'Enterprise-grade Azure architecture, automation, and identity controls for hybrid workloads.',
  },
  {
    name: 'Google Cloud Platform',
    logo: '/images/cloud/gcp.webp',
    description:
      'AI-ready cloud platforms, Kubernetes orchestration, and data analytics on Google Cloud.',
  },
];

export default function Providers() {
  return (
    <div className="providers-grid">
      {providers.map((provider) => (
        <article className="provider-card" key={provider.name} tabIndex="0">
          <div className="provider-logo">
            <img src={provider.logo} alt={`${provider.name} logo`} />
          </div>
          <h3>{provider.name}</h3>
          <p>{provider.description}</p>
        </article>
      ))}
    </div>
  );
}
